import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Switch, Route } from 'react-router-dom';
import App from '@/App';
import Layout from '@/components/pc/Layout';
import Submitted from '@/components/pc/Submitted';
import StateInfo from '@/components/pc/Lottery/StateInfo';
import './index.less';
var Root = /*#__PURE__*/function (_Component) {
  _inherits(Root, _Component);
  function Root() {
    _classCallCheck(this, Root);
    return _possibleConstructorReturn(this, _getPrototypeOf(Root).apply(this, arguments));
  }
  _createClass(Root, [{
    key: "render",
    value: function render() {
      var _videoStyle;
      var videoStyle = (_videoStyle = {
        width: 'fit-content'
      }, _defineProperty(_videoStyle, "width", '-webkit-fill-available'), _defineProperty(_videoStyle, "maxHeight", '80vh'), _videoStyle);
      return React.createElement(HashRouter, null, React.createElement(Switch, null, React.createElement(Route, {
        exact: true,
        path: "/submitted",
        component: function component() {
          return React.createElement(App, {
            videoStyle: videoStyle
          }, React.createElement(Submitted, null));
        }
      }), React.createElement(Route, {
        exact: true,
        path: "/info",
        component: function component() {
          return React.createElement(App, {
            videoStyle: videoStyle
          }, React.createElement(StateInfo, null));
        }
      }), React.createElement(Route, {
        path: "/",
        component: function component() {
          return React.createElement(App, {
            videoStyle: videoStyle
          }, React.createElement(Layout, null));
        }
      })));
    }
  }]);
  return Root;
}(Component);
ReactDOM.render(React.createElement(Root, null), document.getElementById('root'));